export default __webpack_public_path__ + "8d2b61575603541066089c45b772f01c.png";